import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Text } from "./Text";
import { Paragraph } from "./Paragraph";
import { Link } from "./Link";
import { LineBreak } from "./LineBreak";
import { Block } from "./Block";
import { Upload } from "./Upload";
import { HorizontalRule } from "./HorizontalRule";
export const List = ({ data, options, level = 0 }) => {
    const populatedChildren = data.children.filter((child) => child.children?.length > 0);
    if (populatedChildren?.length === 0) {
        return null;
    }
    if (data.listType === "number") {
        const list = populatedChildren.flatMap((listChild) => {
            const children = listChild.children.map((listItem, index) => {
                if (listItem.type === "text") {
                    return (_jsx(Text, { data: listItem, options: options }, listItem.text));
                }
                else if (listItem.type === "paragraph") {
                    return _jsx(Paragraph, { data: listItem, options: options }, index);
                }
                else if (listItem.type === "link") {
                    return _jsx(Link, { data: listItem, options: options }, listItem.id);
                }
                else if (listItem.type === "linebreak") {
                    return _jsx(LineBreak, { data: listItem, options: options }, index);
                }
                else if (listItem.type === "block") {
                    return _jsx(Block, { data: listItem, options: options }, index);
                }
                else if (listItem.type === "horizontalrule") {
                    return (_jsx(HorizontalRule, { data: listItem, options: options }, index));
                }
                else if (listItem.type === "upload") {
                    return (_jsx(Upload, { data: listItem, options: options }, listItem.id));
                }
                else {
                    return (_jsx(List, { data: listItem, options: options, level: level + 1 }, index));
                }
            });
            return options?.numberListItem ? (options.numberListItem(listChild, children)) : (_jsx("li", { value: listChild.value, children: children }, listChild.value));
        });
        let style;
        if (level % 5 === 0) {
            style = {
                listStyle: "decimal"
            };
        }
        else if (level % 5 === 1) {
            style = {
                listStyle: "upper-alpha"
            };
        }
        else if (level % 5 === 2) {
            style = {
                listStyle: "lower-alpha"
            };
        }
        else if (level % 5 === 3) {
            style = {
                listStyle: "upper-roman"
            };
        }
        else {
            style = { listStyle: "lower-roman" };
        }
        return options?.numberList ? (options.numberList(data, list, level)) : (_jsx("ol", { className: "list-number", style: style, children: list }));
    }
    else if (data.listType === "check") {
        const list = populatedChildren.flatMap((listChild) => {
            const children = listChild.children.map((listItem, index) => {
                if (listItem.type === "text") {
                    return (_jsx(Text, { data: listItem, options: options }, listItem.text));
                }
                else if (listItem.type === "paragraph") {
                    return _jsx(Paragraph, { data: listItem, options: options }, index);
                }
                else if (listItem.type === "link") {
                    return _jsx(Link, { data: listItem, options: options }, listItem.id);
                }
                else if (listItem.type === "linebreak") {
                    return _jsx(LineBreak, { data: listItem, options: options }, index);
                }
                else if (listItem.type === "block") {
                    return _jsx(Block, { data: listItem, options: options }, index);
                }
                else if (listItem.type === "horizontalrule") {
                    return (_jsx(HorizontalRule, { data: listItem, options: options }, index));
                }
                else if (listItem.type === "upload") {
                    return (_jsx(Upload, { data: listItem, options: options }, listItem.id));
                }
                else {
                    return _jsx(List, { data: listItem, options: options }, index);
                }
            });
            const id = crypto.randomUUID();
            return options?.checkListItem ? (options.checkListItem(listChild, children)) : (_jsxs("li", { "aria-checked": listChild.checked, role: "checkbox", tabIndex: -1, value: listChild.value, children: [_jsx("input", { id: id, type: "checkbox", defaultChecked: listChild.checked }), _jsx("label", { htmlFor: id, children: children })] }, listChild.value));
        });
        return options?.checkList ? (options.checkList(data, list, level)) : (_jsx("ul", { className: "list-check", children: list }));
    }
    else {
        const list = populatedChildren.flatMap((listChild) => {
            const children = listChild.children.map((listItem, index) => {
                if (listItem.type === "text") {
                    return (_jsx(Text, { data: listItem, options: options }, listItem.text));
                }
                else if (listItem.type === "paragraph") {
                    return _jsx(Paragraph, { data: listItem, options: options }, index);
                }
                else if (listItem.type === "link") {
                    return _jsx(Link, { data: listItem, options: options }, listItem.id);
                }
                else if (listItem.type === "linebreak") {
                    return _jsx(LineBreak, { data: listItem, options: options }, index);
                }
                else if (listItem.type === "block") {
                    return _jsx(Block, { data: listItem, options: options }, index);
                }
                else if (listItem.type === "horizontalrule") {
                    return (_jsx(HorizontalRule, { data: listItem, options: options }, index));
                }
                else if (listItem.type === "upload") {
                    return (_jsx(Upload, { data: listItem, options: options }, listItem.id));
                }
                else if (listItem.tag === "h4") {
                    return (_jsx(_Fragment, { children: listItem.children.map((item) => (_jsx("span", { children: item.text }))) }));
                }
                else {
                    return _jsx(List, { data: listItem, options: options }, index);
                }
            });
            return options?.bulletListItem ? (options.bulletListItem(listChild, children)) : (_jsx("li", { value: listChild.value, children: children }, listChild.value));
        });
        if (!data.listType) {
            if (data.tag === "ol") {
                return options?.bulletList ? (options.bulletList(data, list, level)) : (_jsx("ol", { className: "list-bullet", children: list }));
            }
            else if (data.tag === "ul") {
                return options?.bulletList ? (options.bulletList(data, list, level)) : (_jsx("ul", { className: "list-bullet", children: list }));
            }
        }
        return options?.bulletList ? (options.bulletList(data, list, level)) : (_jsx("ul", { className: "list-bullet", children: list }));
    }
};
